import { render } from "./ActiveHygieneCert.vue?vue&type=template&id=0bc21fbd&scoped=true"
import script from "./ActiveHygieneCert.vue?vue&type=script&lang=js"
export * from "./ActiveHygieneCert.vue?vue&type=script&lang=js"

import "./ActiveHygieneCert.vue?vue&type=style&index=0&id=0bc21fbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc21fbd"]])

export default __exports__